import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader,
  })
}

export const loaderComputed = {
  ...mapState('loader', {
    loading: (state) => state.loading
  })
}

export const errorsComputed = {
  ...mapState('errors', {
    errorStatus: (state) => state.loading
  })
}

export const sessaoComputed = {
  ...mapState('sessao', {
    categoriasResponse: (state) => state.categoriasResponse,
    marcasResponse: (state) => state.marcasResponse,
  })
}

export const taxonomiaComputed = {
  ...mapState('taxonomia', {
    editedItem: (state) => state.editedItem,
    expand: (state) => state.expand,
    errorStatus: (state) => state.errorStatus,
    taxonomiaCategorias: (state) => state.taxonomiaCategorias,
    categoriasSelected: (state) => state.categoriasSelected,
    imgAlta: (state) => state.imgAlta,
    loadingProdutos: (state) => state.loadingProdutos,
    produtosResponse: (state) => state.produtosResponse,
    produtoCategoriaChanged: (state) => state.produtoCategoriaChanged,

    // 
    categoriaSemSegmento: (state) => state.categoriaSemSegmento,
    categoriaDetails: (state) => state.categoriaDetails,
  })
}

export const cadastroBasicoComputed = {
  ...mapState('cadastrobasico', {
    empresaDetails: (state) => state.empresaDetails,
  })
}

export const produtoComputed = {
  ...mapState('produto', {
    listagemSelected: (state) => state.listagemSelected,
    loadingProdutosAtivos: (state) => state.loadingProdutosAtivos,
    produtosAtivos: (state) => state.produtosAtivos,
    produtoDetail: (state) => state.produtoDetail,
    nextProdutoDetail: (state) => state.nextProdutoDetail,
    produtoAtual: (state) => state.produtoAtual,
    currentPage: (state) => state.currentPage,
    filtroPendente: (state) => state.filtroPendente,
    imagensResponse: (state) => state.imagensResponse,
    novaBusca: (state) => state.novaBusca,
    novoCadastro: (state) => state.novoCadastro,
  })
}

export const fotografiaComputed = {
  ...mapState('fotografia', {
    produtosSemCadastroResponse: (state) => state.produtosSemCadastroResponse,
    produtoSemCadastroSelected: (state) => state.produtoSemCadastroSelected,
    fotografiaProdutoDetails: (state) => state.fotografiaProdutoDetails,
    fotografiaEmpresasResponse: (state) => state.fotografiaEmpresasResponse,
  })
}

export const tokenComputed = {
  ...mapGetters('token', [
    'username',
    'authorities'
  ])
}

export const keycloakComputed = {
  ...mapState('keycloak', {
    token: (state) => state.token,
    tokenParsed: (state) => state.tokenParsed,
  })
}


export const windowComputed = {
  ...mapState('window', {
    windowWidth: (state) => state.windowWidth,
    xxl: (state) => state.xxl,
    xl: (state) => state.xl,
    lg: (state) => state.lg,
    md: (state) => state.md,
    sm: (state) => state.sm,
    xm: (state) => state.xm,
    isMobile: (state) => state.isMobile,
    isTablet: (state) => state.isTablet,
    isPhone: (state) => state.isPhone,
    windowHeight: (state) => state.windowHeight,
  })
}

export const authMethods = mapActions('token', ['logout'])

export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeLoaderValue'])

export const loaderMethods = mapActions('loader', ['changeLoading'])

export const errorsMethods = mapActions('errors', ['errorHandler', 'cleanError'])

export const authFackMethods = mapActions('authfack', ['login', 'registeruser', 'logout'])

export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])

export const cadastroBasicoMethods = mapActions('cadastrobasico', [
  'changeEmpresaDetails',
])

export const sessaoMethods = mapActions('sessao', [
  'listCategorias',
  'changeCategoriasResponse',
  'changeMarcasResponse',
])

export const taxonomiaMethods = mapActions('taxonomia', [  
  'changeEditedItem',
  'changeExpand',
  'changeRetract',
  'changeErrorStatus',
  'cleanError',
  'changeTaxonomiaCategorias',
  'changeCategoriasSelected',
  'changeImgAlta',
  'changeLoadingProdutos',
  'changeProdutosResponse',
  'changeProdutoCategoriaChanged',

  // 
  'changeCategoriaSemSegmento',
  "changeCategoriaDetails",
])

export const produtoMethods = mapActions('produto', [
  'listProdutosPendentes',
  'listPesquisaProdutos',
  'changeListagemSelected',
  'changeLoadingProdutosAtivos',
  'changeProdutosAtivos',
  'changeProdutoDetail',
  'changeNextProdutoDetail',
  'changeProdutoAtual',
  'changeCurrentPage',
  'changeFiltroPendente',
  'changeImagensResponse',
  'changeNovaBusca',
  'changeNovoCadastro',
])

export const fotografiaMethods = mapActions('fotografia', [
  'changeProdutosSemCadastroResponse',
  'changeProdutoSemCadastroSelected',
  'changeFotografiaProdutoDetails',
  'changeFotografiaEmpresasResponse',
])

export const keycloakMethods = mapActions('keycloak', [
  'signIn',
  'signOut'
])


export const windowMethods = mapActions('window', [
  'changeWindowWidth', 'changeWindowHeight'
])
